// ACTION
export const CAROUSEL = {
    SET_INDEX: 'SET_INDEX',
};

// ACTION CREATORS
export function setActiveIndex(activeIndex) {
    return async (dispatch) => {
        dispatch({
            type: CAROUSEL.SET_INDEX,
            activeIndex
        })
    }
}
